import { PopoverPlacement } from "@idui/react-popover";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { capitalize } from "@ryde/shared";

import { IRenderColumnTemplate } from "../_core";
import { FramerTooltip } from "../../../common";
import { buildTooltipContent } from "./availability-cell.helpers";
import { useAvailabilityCell } from "./availability-cell.hook";
import {
  CellContentStyled,
  DisplayTextStyled,
  RestCountStyled,
} from "./availability-cell.styled";

export const AvailabilityCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  formAttributes,
  e2eData,
}) => {
  const { t } = useTranslation();
  const { displayValues, displayText, moreItemsCount } = useAvailabilityCell(
    value,
    formAttributes,
  );

  const tooltipContent = useMemo(
    () =>
      buildTooltipContent(
        displayValues,
        capitalize(t("dayGroup.plural")),
        capitalize(t("dayType.plural")),
      ),
    [displayValues, t],
  );

  return (
    <div
      className="cell_simple"
      data-e2e-custom={e2eData}
      data-e2e-template="availability-cell-template"
    >
      <FramerTooltip
        content={tooltipContent}
        placement={PopoverPlacement.topLeft}
      >
        <CellContentStyled>
          <DisplayTextStyled>{displayText}</DisplayTextStyled>
          {Boolean(moreItemsCount) && (
            <RestCountStyled>{`+${moreItemsCount}`}</RestCountStyled>
          )}
        </CellContentStyled>
      </FramerTooltip>
    </div>
  );
};
